import { Link } from "react-router-dom";

export const Logo = ({ className = "" }) => (
  <Link to="/" className={`flex items-center group ${className}`} data-testid="site-logo">
    <img
      src="/hma-logo.png"
      alt="HMA Construction Chemicals"
      className="h-16 w-auto object-contain drop-shadow-md transition-transform group-hover:scale-105"
    />
  </Link>
);
